import { createReducer, type Reducer } from '@reduxjs/toolkit';

import {
  addToFavourites,
  fetchFavourites,
  removeFromFavourites,
} from './actions';

export interface FavouritesState {
  favouritesIds: string[];
  isFavouritesLoaded: boolean;
}

const initialState: FavouritesState = {
  favouritesIds: [],
  isFavouritesLoaded: false,
};

export const favouritesReducer: Reducer<typeof initialState> = createReducer(
  initialState,
  (builder) =>
    builder
      .addCase(fetchFavourites.fulfilled, (state, action) => {
        state.favouritesIds = action.payload.entities.map((entity) => {
          return `${entity.type}:${entity.entity_id}`;
        });
        state.isFavouritesLoaded = true;
      })
      .addCase(addToFavourites.fulfilled, (state, action) => {
        const favouritesId = action.meta.arg;

        if (!state.favouritesIds.includes(favouritesId)) {
          state.favouritesIds.push(favouritesId);
        }
      })
      .addCase(removeFromFavourites.fulfilled, (state, action) => {
        const index = state.favouritesIds.findIndex(
          (favouriteId) => favouriteId === action.meta.arg
        );

        if (index !== -1) {
          state.favouritesIds.splice(index, 1);
        }
      })
);
